//	Internals
import { isEmpty } from "lodash";
//	Externals
import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { URL } from "../../../constants/URL";
import BreadCrumbs from "../../common/breadcrumbs";
import { useGetTransactionsDetails } from "../../../queryHooks/usePayouts";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import { useGetRestaurantSettings } from "../../../queryHooks";

//	Component starts
const TransactionsDetails = () => {
	//	Params
	const { slug } = useParams();
	const [restaurantId, setRestaurantId] = useState();

	const { data: dataTransactionsDetails } = useGetTransactionsDetails(slug);

	useEffect(() => {
		setRestaurantId(dataTransactionsDetails?.data?.restaurant?.restaurant_id);
	}, [dataTransactionsDetails]);

	const { data: restaurantConfigData } = useGetRestaurantSettings(restaurantId);

	return (
		<>
			<div className="d-flex align-items-center justify-content-between flex-wrap mb-2">
				<BreadCrumbs
					title="Payouts Management"
					data={[
						{ label: "Transactions", path: URL.transactions },
						{ label: "Transactions Details" },
					]}
				/>
			</div>
			<div className="content-wrapper order-details-wrap">
				<div className="card p-0">
					<div className="card-body">
						<div className="form-group row">
							<div className="col-md-6">
								<div className="card-box">
									<div className="card-items">
										<h6>Basic Information</h6>
										<p>
											GIFT ID :{" "}
											<strong>
												<Link
													to={{
														pathname: `${URL.giftOrders}/${dataTransactionsDetails?.data?.order_id}`,
													}}
												>
													<span>{dataTransactionsDetails?.data?.order_id}</span>
												</Link>
											</strong>
										</p>
										<p>
											Date :{" "}
											<strong>
												{getCurrentTimezoneDate(
													dataTransactionsDetails?.data?.created_at || "-"
												)}
											</strong>
										</p>

										<p>
											Restaurant Name :{" "}
											<strong>
												<Link
													to={{
														pathname: `${URL.restaurants}/${dataTransactionsDetails?.data?.restaurant_id}`,
													}}
												>
													<span>
														{dataTransactionsDetails?.data?.restaurant?.name}
													</span>
												</Link>
											</strong>
										</p>
									</div>
								</div>
							</div>
							<div className="col-md-6 col-lg-6">
								<div className="card-box">
									<div className="card-items">
										<h6>Order Information</h6>
										<div className="d-flex justify-content-between">
											<p>Gross Amount: </p>
											<span>
												<strong>
													{dataTransactionsDetails?.data?.gross_amount
														? "$ " + dataTransactionsDetails?.data?.gross_amount
														: "--"}
												</strong>
											</span>
										</div>
										<div className="d-flex justify-content-between">
											<p>Discount: </p>
											<span>
												<strong>
													{dataTransactionsDetails?.data?.discount
														? "$ " + dataTransactionsDetails?.data?.discount
														: "--"}
												</strong>
											</span>
										</div>
										{Number(dataTransactionsDetails?.data?.reward_discount) > 0 ? (
											<div className="d-flex justify-content-between">
												<p>
													Reward Discount (OPA funded):{" "}
													<span className="badge badge-success">Reward used</span>
												</p>
												<span>
													<strong>- $ {dataTransactionsDetails?.data?.reward_discount}</strong>
												</span>
											</div>
										) : null}
										<div className="d-flex justify-content-between">
											<p>Estimated Tax Rate: </p>
											<span>
												<strong>
													{dataTransactionsDetails?.data?.tax_rate
														? "$ " + dataTransactionsDetails?.data?.tax_rate
														: "--"}
												</strong>
											</span>
										</div>
										<div className="d-flex justify-content-between">
											<p>Estimated Tax : </p>
											<span>
												<strong>
													{dataTransactionsDetails?.data?.tax
														? "$ " + dataTransactionsDetails?.data?.tax
														: "--"}
												</strong>
											</span>
										</div>
										{restaurantConfigData?.data?.tips_enabled ? (
											<div className="d-flex justify-content-between">
												<p>Tip : </p>
												<span>
													<strong>
														{dataTransactionsDetails?.data?.tip
															? "$ " + dataTransactionsDetails?.data?.tip
															: "--"}
													</strong>
												</span>
											</div>
										) : null}
										{restaurantConfigData?.data?.service_charge_enabled ? (
											<div className="d-flex justify-content-between">
												<p>Service Charge : </p>
												<span>
													<strong>
														{dataTransactionsDetails?.data?.service_charge
															? "$ " +
															  dataTransactionsDetails?.data?.service_charge
															: "--"}
													</strong>
												</span>
											</div>
										) : null}
										<div className="d-flex justify-content-between">
											<p>Net Amount (charged to customer) : </p>
											<span>
												<strong>
													{dataTransactionsDetails?.data?.net_amount
														? "$ " + dataTransactionsDetails?.data?.net_amount
														: "--"}
												</strong>
											</span>
										</div>
										<div className="d-flex justify-content-between">
											<p>Platform Fee : </p>
											<span>
												<strong>
													{dataTransactionsDetails?.data?.platform_fee
														? "$ " + dataTransactionsDetails?.data?.platform_fee
														: "--"}
												</strong>
											</span>
										</div>
										<div className="d-flex justify-content-between">
											<p>Merchant Fee : </p>
											<span>
												<strong>
													{dataTransactionsDetails?.data?.merchant_fee
														? "$ " + dataTransactionsDetails?.data?.merchant_fee
														: "--"}
												</strong>
											</span>
										</div>
										<div className="d-flex justify-content-between">
											<p>
												Net Payable to Restaurant
												{Number(dataTransactionsDetails?.data?.reward_discount) > 0
													? " (paid in full, incl. OPA reward top-up)"
													: ""}{" "}
												:{" "}
											</p>
											<span>
												<strong>
													{dataTransactionsDetails?.data?.net_restaurant_amount
														? "$ " +
														  dataTransactionsDetails?.data
																?.net_restaurant_amount
														: "--"}
												</strong>
											</span>
										</div>
										<div className="d-flex justify-content-between">
											<p>Net Payable to OPA : </p>
											<span>
												<strong>
													{dataTransactionsDetails?.data?.net_platform_amount
														? "$ " +
														  dataTransactionsDetails?.data?.net_platform_amount
														: "--"}
												</strong>
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default TransactionsDetails;
